module.exports = __webpack_public_path__ + "static/media/KMH_5188.fd961e63.jpg";